/** Oltre questa soglia le select del form usano Autocomplete con ricerca. */
export const SELECT_SEARCHABLE_MIN_OPTIONS = 5
